import { render, staticRenderFns } from "./alt-table-limits.vue?vue&type=template&id=4cfadbb8&"
import script from "./alt-table-limits.vue?vue&type=script&lang=ts&"
export * from "./alt-table-limits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports